import { useLanguage } from "@/contexts/LanguageContext";
import { Globe } from "lucide-react";

export function LanguageSwitcher({ variant = "default" }: { variant?: "default" | "compact" }) {
  const { lang, switchLanguage } = useLanguage();

  if (variant === "compact") {
    return (
      <button
        onClick={switchLanguage}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-border text-sm font-medium text-foreground hover:border-primary/40 hover:text-primary transition-colors"
        aria-label="Switch language"
      >
        <Globe className="h-3.5 w-3.5" />
        {lang === "en" ? "العربية" : "EN"}
      </button>
    );
  }

  return (
    <div className="flex items-center gap-1 border border-border rounded-lg p-0.5">
      <button
        onClick={() => lang !== "en" && switchLanguage()}
        className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${
          lang === "en" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
        }`}
      >
        EN
      </button>
      <button
        onClick={() => lang !== "ar" && switchLanguage()}
        className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${
          lang === "ar" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
        }`}
      >
        عربي
      </button>
    </div>
  );
}
